//@flow
import React from 'react';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
// eslint-disable-next-line
import "./styles.scss";

type Props = {
  theme: string,
  data: {
    thinkDesignBanner: any,
  },
};

const ThinkDesignBanner = (props: Props) => {
  const { height, isMobile } = useViewport();

  const {
    title,
    description,
    description_mobile,
    image,
    image_mobile,
    thumbnail,
    thumbnail_mobile,
    banner_video,
  } = props.data.thinkDesignBanner;
  let className = 'thinkDesign-banner';
  let imageUrl = image;
  let thumbNail = thumbnail;

  const animationClasses = ['animate-height', 'animate-width'];

  let bannerText = title;
  if (isMobile) {
    imageUrl = image_mobile;
    thumbNail = thumbnail_mobile;
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'intro'}
        imageUrl={imageUrl}
        thumbNailUrl={thumbNail}
        title={bannerText}
        bannerImage={animationClasses.join(' ')}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {/*<FooterExploreButton theme={theme} onClick={handleClick} />*/}
    </div>
  );
};

export default ThinkDesignBanner;
